import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _ from 'lodash';
import { Bridge } from "./bridge";
export var Translator = /*#__PURE__*/function () {
  function Translator() {
    _classCallCheck(this, Translator);
  }
  _createClass(Translator, null, [{
    key: "initialize",
    value: function initialize() {
      var _this = this;
      Object.keys(this.messages).forEach(function (message) {
        Object.keys(_this.messages[message]).forEach(function (locale) {
          Bridge.addLocale(locale, _defineProperty({}, message, _this.messages[message][locale]), {});
        });
      });
    }
  }]);
  return Translator;
}();
_defineProperty(Translator, "messages", {
  Logout: {
    'zh-CN': '退出登录',
    'hi-IN': 'लॉगआउट करें'
  },
  'Platform Time': {
    'zh-CN': '云平台时间',
    'hi-IN': 'क्लाउड प्लेटफ़ॉर्म का समय'
  },
  'User Center': {
    'zh-CN': '用户中心',
    'hi-IN': 'उपयोगकर्ता केंद्र'
  },
  'Switch Language': {
    'zh-CN': '切换语言',
    'hi-IN': 'भाषा बदलें'
  },
  'License Management': {
    'zh-CN': '授权管理',
    'hi-IN': 'अनुमति प्रबंधन'
  },
  Name: {
    'zh-CN': '名称',
    'hi-IN': 'नाम'
  },
  Description: {
    'zh-CN': '简介',
    'hi-IN': 'संक्षेप'
  },
  'Create {name}': {
    'zh-CN': '创建{name}',
    'hi-IN': 'सृजन{name}'
  },
  'Select {name}': {
    'zh-CN': '选择{name}',
    'hi-IN': 'चुनें{name}'
  },
  'Selected {count} items.': {
    'zh-CN': '已选择 {count} 项',
    'hi-IN': 'चयनित {count} आइटम'
  },
  'I am aware of the aforementioned risks': {
    'zh-CN': '我已知晓上述风险',
    'hi-IN': 'मैं उपरोक्त जोखिमों के बारे में जागरूक हूँ'
  },
  'This action cannot be restored once executed, please operate with caution.': {
    'zh-CN': '此动作一经执行不可恢复, 请谨慎操作。',
    'hi-IN': 'यह कार्रवाई अस्थायी रूप से हो जाएगी, कृपया सतर्क रहें।'
  },
  'Invalid credentials': {
    'zh-CN': '无效的凭据',
    'hi-IN': 'अमान्य क्रेडेंशियल्स'
  },
  'The current login credentials have expired. Please log in again.': {
    'zh-CN': '当前登录凭据已过期，请重新登录。',
    'hi-IN': 'वर्तमान लॉगिन क्रेडेंशियल्स की समय सीमा समाप्त हो गई है, कृपया फिर से लॉगिन करें।'
  },
  Identifier: {
    'zh-CN': '编号',
    'hi-IN': 'आईडी'
  },
  'Universally Unique Identifier': {
    'zh-CN': '唯一标识符',
    'hi-IN': 'अद्वितीय पहचानकर्ता'
  },
  'Created At': {
    'zh-CN': '创建于',
    'hi-IN': 'में बनाया गया'
  },
  'Updated At': {
    'zh-CN': '更新于',
    'hi-IN': 'में अपडेट किया गया'
  },
  Action: {
    'zh-CN': '操作',
    'hi-IN': 'क्रिया'
  },
  Deselect: {
    'zh-CN': '取消选择',
    'hi-IN': 'चयन रद्द करें'
  },
  'Batch Delete': {
    'zh-CN': '批量删除',
    'hi-IN': 'बैच में हटाएं'
  },
  'Are you sure you want to delete this data?': {
    'zh-CN': '确定要删除这些数据?',
    'hi-IN': 'क्या आप इन डेटा को हटाना चाहते हैं?'
  },
  Filter: {
    'zh-CN': '筛选',
    'hi-IN': 'फ़िल्टर'
  },
  Key: {
    'zh-CN': '键',
    'hi-IN': 'कुंजी'
  },
  Value: {
    'zh-CN': '值',
    'hi-IN': 'मान'
  },
  Operator: {
    'zh-CN': '操作符',
    'hi-IN': 'ऑपरेटर'
  },
  'Equal To': {
    'zh-CN': '等于',
    'hi-IN': 'के बराबर'
  },
  'Greater Than': {
    'zh-CN': '大于',
    'hi-IN': 'से अधिक'
  },
  'Less Than': {
    'zh-CN': '小于',
    'hi-IN': 'से कम'
  },
  'Similar To': {
    'zh-CN': '相似于',
    'hi-IN': 'के समान'
  },
  'Not Similar To': {
    'zh-CN': '不相似于',
    'hi-IN': 'के समान नहीं'
  },
  In: {
    'zh-CN': '在之中',
    'hi-IN': 'बिच में'
  },
  'Not In': {
    'zh-CN': '不在之中',
    'hi-IN': 'बीच में नहीं'
  },
  Between: {
    'zh-CN': '在之间',
    'hi-IN': 'बीच में'
  },
  'Not Between': {
    'zh-CN': '不在之间',
    'hi-IN': 'बीच में नहीं'
  },
  'Not Equal To': {
    'zh-CN': '不等于',
    'hi-IN': 'के बराबर नहीं'
  },
  'Greater Than Or Equal To': {
    'zh-CN': '大于等于',
    'hi-IN': 'से अधिक या बराबर'
  },
  'Less Than Or Equal To': {
    'zh-CN': '小于等于',
    'hi-IN': 'से कम या बराबर'
  },
  'More Options': {
    'zh-CN': '更多操作',
    'hi-IN': 'अधिक कार्रवाई'
  },
  'Automatic Recognition': {
    'zh-CN': '自动识别',
    'hi-IN': 'स्वचालित',
    'en-US': 'Auto'
  },
  'Go Back': {
    'zh-CN': '返回上一页',
    'hi-IN': 'पिछले पृष्ठ पर जाएं'
  },
  'Learn More': {
    'zh-CN': '了解更多',
    'hi-IN': 'और अधिक जानें'
  },
  Total: {
    'zh-CN': '总数',
    'hi-IN': 'कुल'
  },
  'Your device is currently unable to provide an available authenticator.': {
    'zh-CN': '您的设备暂时无法提供可用的身份验证器。',
    'hi-IN': 'आपकेयंत्र समय-समय पर उपयोग के लिए उपलब्ध एक प्रमाणीकरण उपकरण प्रदान नहीं कर सकता है।'
  },
  'Your browser does not have network authentication services.': {
    'zh-CN': '您的浏览器暂无网络身份验证服务。',
    'hi-IN': 'आपका ब्राउज़र नेटवर्क प्रमाणीकरण सेवा का समर्थन नहीं करता है।'
  },
  '{title} in progress': {
    'zh-CN': '{title}正在进行中',
    'hi-IN': '{title}प्रगति पर है'
  },
  '{title} successfully completed': {
    'zh-CN': '{title}已成功',
    'hi-IN': '{title}सफलतापूर्वक पूर्ण'
  },
  '{title} failed': {
    'zh-CN': '{title}已失败',
    'hi-IN': '{title}विफल हो गया'
  },
  'This setting will take effect on the next login.': {
    'zh-CN': '本次设置将在下一次登录时生效。'
  }
});
_defineProperty(Translator, "formatMessage", function (descriptor, values, opts) {
  var _$get;
  // -
  var intl = (_$get = _.get(opts, ['intl'])) !== null && _$get !== void 0 ? _$get : Bridge.getIntl();
  // -
  if (intl.messages[descriptor.id]) {
    // 如果有匹配的消息则直接返回
    return intl.formatMessage(descriptor, values, opts);
  } else {
    var _descriptor$defaultMe;
    // 如果没有匹配的消息则按前缀查找看是否有匹配的消息
    var realMessage = Object.keys(intl.messages).find(function (message) {
      return message.startsWith(descriptor.id || '');
    });
    // 不管能不能找到匹配的消息都直接返回，让 react-intl 去决定接下来怎么做
    return intl.formatMessage(_objectSpread(_objectSpread({}, descriptor), {}, {
      id: realMessage !== null && realMessage !== void 0 ? realMessage : descriptor.id,
      defaultMessage: (_descriptor$defaultMe = descriptor.defaultMessage) !== null && _descriptor$defaultMe !== void 0 ? _descriptor$defaultMe : descriptor.id
    }), values, opts);
  }
});
export var useSuperIntl = function useSuperIntl() {
  // 获取原始 IntlShape 对象
  var intl = Bridge.useIntl();

  // 修改 IntlShape 对象
  // > 备份 formatMessage
  if (!_.has(intl, 'formatMessage0')) {
    _.set(intl, 'formatMessage0', intl.formatMessage);
  }
  // > 修改 formatMessage
  intl.formatMessage = function (descriptor, values, opts) {
    // 重设参数
    // > -
    var nonNullableOpts = opts || {};
    // > -
    _.set(nonNullableOpts, 'intl', _objectSpread(_objectSpread({}, intl), {}, {
      formatMessage: _.get(intl, 'formatMessage0')
    }));
    // 调用
    return Translator.formatMessage(descriptor, values, nonNullableOpts);
  };

  // 返回修改过的 IntlShape 对象
  return intl;
};